module.exports = __webpack_public_path__ + "static/img/9413bac39bdd69a6ff652f479658ca4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon1.jpg
// module id = Hnt7
// module chunks = 1